import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { INSAutoCompleteGroup, INSAutoCompleteOption } from '@norfolk-southern/accessns-components';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ng-permit-search-dialog',
  templateUrl: './permit-search.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PermitSearchDialogComponent implements OnChanges, OnDestroy {
  @Input() commodities: Array<INSAutoCompleteOption> = [];
  @Input() permits: Array<INSAutoCompleteOption> = [];
  @Input() searchingPermits = false;
  @Output() searchPermits = new EventEmitter<{ commodity: string; search: string }>();
  @Output() loadPermit = new EventEmitter<{ permitName: string; permitId: string; permitType: string }>();
  form = new UntypedFormGroup({
    commodity: new UntypedFormControl(undefined, Validators.required),
    permitNumber: new UntypedFormControl(undefined, Validators.required),
    permitNumberSearch: new UntypedFormControl(undefined)
  });
  private subscriptionNotifier = new Subject<void>();

  constructor(private dialogRef: MatDialogRef<PermitSearchDialogComponent>) {
    this.setup();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.commodities?.currentValue && this.commodities && this.commodities.length > 0) {
      this.form.controls.commodity.setValue(this.commodities[0].key);
    }
  }

  ngOnDestroy(): void {
    this.subscriptionNotifier.next();
    this.subscriptionNotifier.complete();
  }

  /**
   * Emit Load Permit
   *
   * @summary Emit Load Permit
   * @return void
   */
  emitLoadPermit(): void {
    const data: { permitNumber: INSAutoCompleteOption } = this.form.value;
    const [permitName] = data.permitNumber.value.split(' ');
    const [permitId, permitType] = data.permitNumber.key.split('-');
    this.loadPermit.emit({ permitName, permitId, permitType });
    this.dialogRef.close({ permitName, permitId, permitType });
  }

  /**
   * Select Permit
   *
   * @summary Emit Load Permit
   * @return void
   */
  selectPermit($permit: INSAutoCompleteOption | INSAutoCompleteGroup): void {
    this.form.controls.permitNumber.setValue($permit);
  }

  private setup(): void {
    this.form.controls.permitNumberSearch.valueChanges.pipe(
      takeUntil(this.subscriptionNotifier),
      filter(value => !!value),
      debounceTime(250),
      distinctUntilChanged()
    ).subscribe((value: string | INSAutoCompleteOption) => {
      if (typeof value === 'string') {
        const commodity = this.form.controls.commodity.value;
        this.searchPermits.emit({ commodity, search: value });
      }
    });
  }
}
